<template>
  <div>
    <div v-if="path" class="row no-gutters">
      <div class="col-3">
        <label
          v-tooltip="uniToolTipTranslation('S422', 'en-US')"
          class="label-unidato fluidSelectLabel"
        >
          {{ uniTranslation("S422") }}</label
        >
      </div>
      <div class="col-9">
        <el-select
          v-if="fluidList.length == 0"
          v-model="dummy"
          class="fluidSelect"
          placeholder="..."
          filterable
          disabled
        >
          <el-option :key="-1" :value="-1" :label="'...'">...</el-option>
        </el-select>
        <el-select
          v-if="fluidList.length > 0"
          v-model="selectedFluid"
          class="fluidSelect"
          placeholder="..."
          filterable
        >
          <el-option
            v-for="item in fluidList"
            :key="item.webId"
            :label="uniTranslation(item.idT)"
            :value="item.webId"
          >
            <!-- 
              v-if="item.fast !== 0"
              v-tooltip="uniToolTipTranslation(item.description, 'en-US')"-->

            <span style="float: left"
              ><i class="fa fa-tint"></i> {{ uniTranslation(item.idT) }}</span
            >
          </el-option>
          <!--
          <el-option-group v-for="group in fluidTypologies" :key="group.id" :label="group.typology">
            <el-option
              v-for="item in fluidList"
              v-if="item.tipologia == group.id && item.fast === 0"
              :key="item.webId"
              :label="uniTranslation(item.idT)"
              :value="item.webId"
            >
          <-- 
              v-tooltip="uniToolTipTranslation(item.description, 'en-US')"- ->

              <span style="float: left">{{ uniTranslation(item.idT) }}</span>
              <span class="numberCircle">{{ group.shortDescr }} </span>
            </el-option>
          </el-option-group>
          -->
        </el-select>
      </div>
    </div>
    <div>
      <UnidataEditor v-show="requiresConcentration" :parent-path="path" :name="'.concetration'">
      </UnidataEditor>
      <UnidataEditor v-show="requiresPressure" :parent-path="path" :name="'.fluidPressure'">
      </UnidataEditor>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Select, Option, OptionGroup } from "element-ui";
import UnidataEditor from "../unidata/UnidataEditor";
// import UnidataEditorCorrelator from "../unidata/UnidataEditorCorrelator";
// import UnidataEditorCorrelatorOptionList from "../unidata/UnidataEditorCorrelatorOptionList";
import generalService from "../../services/backendCipriani/generalService";
//import fluidService from "../../services/backend/fluidService";
import jsonHelper from "../../shared/jsonHelper";

export default {
  components: {
    "el-select": Select,
    "el-option-group": OptionGroup,
    "el-option": Option,
    UnidataEditor /*,
    UnidataEditorCorrelator,
    UnidataEditorCorrelatorOptionList*/
  },
  props: {
    path: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selectedFluid: "",
      fluidTypologies: [],
      fluidList: [],
      requiresConcentration: false,
      requiresPressure: false,
      dummy: -1,
      lastListCode: null
    };
  },
  computed: {
    ...mapGetters(["projects","fluidsDictionary"])
  },
  watch: {
    selectedFluid: function(nv, ov) {
      if (nv && ov && nv != ov) {
        /* nv != null && nv != undefined */
        var that = this;
        var tipologia = parseInt(nv / 10000);
        var idf = parseInt(nv % 10000);

        //alert(this.path + ".fluid.webId becomes " + tipologia + " " + idf);

        this.$store.dispatch("changeProjectProperty", {
          path: this.path + ".fluid.tipologia",
          value: tipologia
        });

        this.$store.dispatch("changeProjectProperty", {
          path: this.path + ".fluid.id",
          value: idf
        });

        var fld = that.fluidList.find(function(obj) {
          return obj.id === idf;
        });

        that.requiresConcentration = tipologia == 12;
        that.requiresPressure = fld.requiredPressure !== 0;

        /*this.$store.dispatch("changeProjectProperty", {
            path: this.path + ".fluid.id",
            value: idf
          });*/

        that.$store.dispatch("userInputChanged", {
          path: that.path + ".input.usrValue.value",
          value: that.inputVal
        });
      }
    }
  },
  mounted: function() {
    var that = this;
    that.$store.subscribe(function(mutation /*, state*/) {
      if (mutation.type === "changeTypeOfPhe" || mutation.type === "changeLanguage") {
        that.lastListCode = null;
        that.updateFluidList();
      }
    });
    that.$nextTick(function() {
      that.updateFluidList();
    });
  },
  methods: {
    updateFluidList() {
      var that = this;
      that.requiresConcentration = false;
      that.requiresPressure = false;
      that.fluidList = [];
      that.fluidTypologies = [];
      var code = this.$store.getters.typeOfPhe;
      console.log("code => " + code);
      if (code) {
      console.log(that.lastListCode + " == null || " + that.lastListCode +" !=  " + code);
        if (that.lastListCode == null || that.lastListCode != code) {
          that.lastListCode = code;
          //generalService.getFluids(code).then(function(data) {
            var data = that.fluidsDictionary[code+''];
            that.fluidList = [];
            data.forEach(element => {
              that.fluidList.push({
                filename: element.filename,
                description: element.filename
                  .split(".")
                  .slice(0, -1)
                  .join("."),
                idT: "GF" + element.descriptionId,
                id: element.id,
                tipologia: element.tipologia,
                orderId: element.orderId,
                requiredPressure: element.requiredPressure,
                tipoStruttura: element.tipoStruttura,
                fast: element.fast,
                webId: element.tipologia * 10000 + element.id
              });
            });

            that.fluidList = that.fluidList.sort((a, b) => {
              const itmA = that.uniTranslation(a.idT).toUpperCase();
              const itmB = that.uniTranslation(b.idT).toUpperCase();

              let comparison = 0;
              if (itmA > itmB) {
                comparison = 1;
              } else if (itmA < itmB) {
                comparison = -1;
              }
              return comparison;
            });

            var selectedFluid = -1;
            var wantedSelectedFluid =
              jsonHelper.getProperty(that.projects, that.path + ".fluid.tipologia") * 10000 +
              jsonHelper.getProperty(that.projects, that.path + ".fluid.id");

            that.fluidList.find(item => {
              if (selectedFluid == -1) {
                selectedFluid = item.webId;
              }
              if (item.webId == wantedSelectedFluid) {
                selectedFluid = wantedSelectedFluid;
              }
            });

            //console.log("CCCC => " + that.selectedFluid);
            that.selectedFluid = selectedFluid;
          //});
        }
      }

      that.fluidTypologies.push({
        id: 11,
        typology: "Pure liquids",
        shortDescr: "PL"
      });

      that.fluidTypologies.push({
        id: 12,
        typology: "Mixed liquids",
        shortDescr: "ML"
      });

      that.fluidTypologies.push({
        id: 13,
        typology: "Pure gases",
        shortDescr: "PG"
      });

      that.fluidTypologies.push({
        id: 14,
        typology: "Mixed gases",
        shortDescr: "MG"
      });
    }
  }
};
</script>

<style lang="scss">
.fluidSelectRow {
  margin-right: 0px;
  margin-left: 0px;
  .col-3 {
    padding-right: 0px;
    padding-left: 0px;
  }
  .col-9 {
    padding-right: 0px;
    padding-left: 0px;
  }
}
.fluidSelectLabel {
  margin-top: 5px;
  //padding-left: 5px;
}
.fluidSelect {
  width: 100%;
  margin-bottom: 10px;
  margin-top: 5px;
  padding: 0 5px;
  .el-input {
    .el-input__inner {
      height: 30px;
    }
  }
}
.numberCircle {
  float: right;
  color: #8492a6;
  font-size: 10px;

  /*border-style: solid; 
    border-width: 1px;
    border-radius: 50%;
    border: 2px solid #666;
    width: 24;
    height: 32px;*/
  text-align: center;
  vertical-align: middle;

  /*border-radius: 50%;
    / *behavior: url(PIE.htc); /* remove if you don't care about IE8 * /

    width: 32px;
    height: 32px;
    padding-top: 0px;
    padding-right: 0px;
    padding-bottom: 0px;
    padding-left: 0px;
    
    background: #fff;
    border: 2px solid #666;
    color: #666;
    text-align: center;
    vertical-align: middle;
    
    / *font: 32px Arial, sans-serif;*/
}
</style>
